export const accessTokenSelector = (state) => state.auth.data.access_token;
export const authAccessParamsSelector = (state) => state.auth.data;
export const authStatusSelector = (state) => state.auth.status;
//# sourceMappingURL=selectors.js.map